import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="bg-background-100/70 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600">
            按类型浏览你感兴趣的纲手本子内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className="group flex items-center gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.count} 篇作品</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 ml-auto group-hover:text-primary-500 transition-colors"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}